export function getAppConfig() {
    return window['runConfig'];
}
